<template>
  <div class="mall_wrap">
    <Nav :subNav="'兑换记录'" :isShowBack="1"></Nav>
    <div class="mall_left_wrap">
      <div class="history_title_wrap">
        <div class="history_back_btn" @click="goBack" v-if="false"></div>
        <div class="history_title">兑换记录</div>
      </div>
      <div class="history_list">
        <div class="history_list_item" :key="item.utime" v-for="item in list">
          <div class="history_list_item_img">
            <img :src="item.large_img" />
          </div>
          <div class="history_list_item_info">
            <div class="name">{{ item.name }}</div>
            <div class="code" v-if="item.account">
              兑换账号：{{ item.account ? item.account : "无" }}
            </div>
            <div class="code" v-else>
              兑换码：{{ item.code ? item.code : "无" }}
            </div>
            <div class="history_list_item_time">兑换日期：{{ item.date }}</div>
          </div>
          <div
            :class="{
              history_list_item_icon_bg: true,
              failed: item.state != 'success' ? true : false,
            }"
          ></div>
          <div class="history_list_item_icon" v-if="item.state == 'success'">
            已兑换
          </div>
          <div
            class="history_list_item_icon"
            v-else-if="
              item.state == 'processing' ||
              item.state == 'untreated' ||
              item.state == 'progress'
            "
          >
            兑换中
          </div>
          <div class="history_list_item_icon" v-else>兑换失败</div>
        </div>
        <div class="history_null_tips" v-if="list.length <= 0">
          暂无兑换记录
        </div>
      </div>
    </div>
    <div class="mall_right_wrap">
      <JdbRank class="jdb_rank"></JdbRank>
    </div>
  </div>
</template>

<script>
import JdbRank from "@/components/JdbRank.vue";
import Nav from "@/components/Common/Nav.vue";
import { mapActions } from "vuex";
export default {
  components: {
    JdbRank,
    Nav,
  },
  data: function () {
    return {
      list: [],
    };
  },
  methods: {
    ...mapActions(["getExchangeList"]),
    goBack: function () {
      this.$router.back(-1);
    },
    getTimeString: function (timestamp) {
      let date = new Date(timestamp * 1000);
      return this.dateFormat("YYYY-mm-dd HH:MM:SS", date);
    },
    dateFormat: function (fmt, date) {
      let ret;
      let opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },
    getList: function () {
      let _that = this;
      let reqData = {
        uid: _that.$store.state.user.uid,
        count: 100,
        page: 1,
        owcode: _that.$store.state.user.owcode,
      };

      _that.getExchangeList([
        reqData,
        function (err, data) {
          if (err) {
            console.log(err);
            return;
          }

          _that.list = [];

          if (data.data && data.data.length > 0) {
            for (let index = 0; index < data.data.length; index++) {
              const item = data.data[index];
              item.date = _that.dateFormat(
                "YYYY-mm-dd",
                new Date(item.timestamp * 1000)
              );
            }
            _that.list = data.data;
          }
        },
      ]);
    },
  },
  mounted: function () {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.mall_wrap {
  width: 960px;
  height: 550px;
  background-color: #f5f5f5;
  text-align: left;
  .mall_left_wrap {
    width: 655px;
    height: 500px;
    display: inline-block;
    vertical-align: top;
    margin-left: 8px;
    border: 1px solid #4366b5;
    border-radius: 2px;
    overflow: hidden;
    background-color: #ffffff;
  }
  .mall_right_wrap {
    width: 275px;
    height: 500px;
    display: inline-block;
    vertical-align: top;
    margin-left: 10px;
    border: 1px solid #4366b5;
    border-radius: 2px;
    .jdb_rank {
    }
  }
}

.history_title_wrap {
  margin-top: 5px;
  padding-top: 1px;
  margin-left: 10px;
  margin-right: 10px;
  border-bottom: 1px solid #f1f2f4;
}

.history_back_btn {
  width: 16px;
  height: 16px;
  background-image: url("../assets/mall/back.png");
  background-size: 100% 100%;
  margin-top: 9px;
  cursor: pointer;
  display: inline-block;
  vertical-align: top;
}

.history_title {
  background-image: url("../assets/mall/history_title.png");
  background-repeat: no-repeat;
  background-position: left 8px;
  height: 34px;
  line-height: 34px;
  padding-left: 20px;
  margin-left: 5px;
  margin-top: 0px;
  display: inline-block;
  vertical-align: top;
}

.history_list::-webkit-scrollbar {
  display: none;
}
.history_list {
  width: 640px;
  margin: 0 auto;
  margin-top: 10px;
  min-height: 400px;
  height: 455px;
  overflow-y: scroll;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  .history_list_item:hover {
    background-color: #fffdeb;
  }

  .history_list_item {
    background-color: #f5f5f5;
    border-radius: 3px;
    overflow: hidden;
    position: relative;
    margin-bottom: 10px;
    width: 305px;
    width: 300px\0;
    display: inline-block;
    vertical-align: top;
    margin-left: 9px;

    .history_list_item_img {
      display: inline-block;
      vertical-align: middle;
      width: 100px;
      margin: 14px 10px;
      border-radius: 5px;
      overflow: hidden;
      font-size: 0;
      img {
        width: 100%;
        min-height: 55px;
        height: 55px\0;
      }
    }
    .history_list_item_info {
      display: inline-block;
      vertical-align: middle;
      .name {
        color: #666666;
        font-size: 13px;
      }
      .code {
        color: #888fa4;
        font-size: 10px;
        margin-top: 4px;
      }
    }
    .history_list_item_time {
      display: inline-block;
      color: #999999;
      font-size: 10px;
      right: 10px;
      bottom: 5px;
    }
    .history_list_item_icon_bg {
      position: absolute;
      bottom: -45px;
      right: -45px;
      width: 88px;
      height: 88px;
      background-color: #fcc11a;
      background: linear-gradient(157deg, #fcc11a 0%, #faaf1b 100%);
      transform: rotate(45deg);
    }
    .history_list_item_icon_bg.failed {
      background: #999999;
    }
    .history_list_item_icon {
      position: absolute;
      right: 2px;
      bottom: 13px;
      font-size: 10px;
      color: #ffffff;
      transform: rotate(-45deg);
    }
  }

  table {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    border-radius: 5px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    thead {
      background-color: #03d96a;
      background-image: linear-gradient(to bottom, #03d96a, #06b65b);
      height: 25px;
      line-height: 25px;
      color: #ffffff;
      tr {
        td {
          font-size: 12px;
        }
      }
    }
    tbody {
      font-size: 9px;
      color: #666666;
      line-height: 20px;
      td {
        padding: 5px 0;
      }
      tr:nth-child(2n) {
        background-color: #ececec;
      }
      tr:nth-child(2n + 1) {
        background-color: #f5f5f5;
      }
    }
    .type {
      min-width: 40px;
    }
    .name {
      max-width: 60px;
      padding: 5px;
    }
    .code {
      word-break: break-all;
    }
    .time {
      padding: 5px;
    }
  }
}
.history_null_tips {
  color: #666666;
  font-size: 10px;
  text-align: center;
  width: 100%;
  background-color: #ffffff;
  height: 40px;
  line-height: 40px;
  margin-top: 10px;
  border-radius: 5px;
}
.history_bottom_tips {
  font-size: 10px;
  position: absolute;
  bottom: 20px;
  text-align: center;
  left: 0;
  width: 100%;
  color: #999999;
  background-color: #ffffff;
}
.history_bottom_line_left {
  position: absolute;
  bottom: 8px;
  left: 20%;
  background-color: #cccccc;
  width: 7%;
  height: 1px;
}
.history_bottom_line_right {
  position: absolute;
  bottom: 8px;
  right: 20%;
  background-color: #cccccc;
  width: 7%;
  height: 1px;
}
</style>